import axios from 'axios';
import {APIURL} from '../consts';

export const useArea = () => {
  const getListPkCode = async (tokens_session) => {
    const response = await axios.get(APIURL.map_pk_code_get_all, {
      headers: {
        Authorization: `Bearer ${tokens_session}`,
      },
    });
    return response;
  };
  const searchDigitalMapping = async (tokens_session, payload) => {
    const response = await axios.post(APIURL.map_search, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${tokens_session}`,
      },
    });
    return response;
  };
  return {
    getListPkCode,
    searchDigitalMapping,
  };
};
